import React, { PureComponent } from 'react';
import Switch from 'rc-switch';
import { Trans } from '@lingui/macro';
import cn from 'classnames';

import StationOdRank from './od/StationOdRank';
import { odDealReturnCount, odDealBorrowCount } from '../utils/odDeal';
import styles from './ODRank.module.scss';

class ODrank extends PureComponent {
    constructor(props) {
        super(props);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.state = {
            showPercent: false,
        };
    }

    handleSwitchChange(value) {
        this.setState({ showPercent: value });
    }

    render() {
        const {
            selectYearMonth,
            showBorrow,
            showReturn,
            odCount,
            station,
            geo,
            highlight,
            handleMouseEnterStation,
            handleMouseLeaveStation,
            hideOtherStation,
            isMobile,
            handleClickBorrow,
            handleClickReturn,
            toggleHideOtherStation,
        } = this.props;
        const { showPercent } = this.state;
        const sameProps = {
            showPercent,
            geo,
            highlight,
            handleMouseEnterStation,
            handleMouseLeaveStation,
            fromStation: station,
            isMobile,
        };
        let borrowTable;
        let returnTable;

        if (station !== 'all') {
            const { borrowCount, totalBorrowCount } = odDealBorrowCount(
                odCount,
                selectYearMonth,
                station,
                true,
            );
            borrowTable = (
                <StationOdRank
                    data={borrowCount}
                    totalNum={totalBorrowCount}
                    type="borrow"
                    handleClick={handleClickBorrow}
                    show={showBorrow}
                    {...sameProps}
                />
            );

            const { returnCount, totalReturnCount } = odDealReturnCount(
                odCount,
                selectYearMonth,
                station,
                true,
            ); // 與Map.js重複計算了 => need to refactor
            returnTable = (
                <StationOdRank
                    data={returnCount}
                    totalNum={totalReturnCount}
                    type="return"
                    handleClick={handleClickReturn}
                    show={showReturn}
                    {...sameProps}
                />
            );
        }
        return (
            <div>
                <div className={styles.odRankWrapper}>
                    <h3 className={styles.odRankTitle}>
                        <Trans id="od.odRank" />
                    </h3>
                    {!isMobile ? (
                        <button
                            type="button"
                            className={cn('btn btn-default', styles.btnFunctional)}
                            onClick={toggleHideOtherStation}
                        >
                            {hideOtherStation
                                ? <Trans id="od.showOtherStation" />
                                : <Trans id="od.hideOtherStation" />
                            }
                        </button>
                    ) : null}
                </div>
                <div className="switch-wrapper">
                    <span>#</span>
                    <Switch onChange={this.handleSwitchChange} />
                    <span>%</span>
                </div>
                <p className="hoverNote" style={{ color: '#999' }}>
                    (
                    <Trans id="activity.hoverNote" />
                    )
                </p>
                <div className="row">
                    <div className="col-md-6 col-xs-6">{borrowTable}</div>
                    <div className="col-md-6 col-xs-6">{returnTable}</div>
                </div>
            </div>
        );
    }
}

export default ODrank;
